import React from "react";
import { Field } from "redux-form";
import { ReduxControls, Icon } from "rhombus-react";

import "./TextFieldArray.css";

export default function TextFieldArray(props){
	const {
		fields,
		addRowLabel,
		maxInputs,
		placeholder,
		onBlur,
	} = props;

	const canAddInput = fields.length < maxInputs;
	const canRemoveInput = fields.length > 1;

	function addInput(){
		if(!canAddInput){ return; }
		fields.push("");
	}

	function removeInput(name, index) {
		if(!canRemoveInput) { return; }
		fields.remove(index);
	}

	const $inputs = fields.map((name, index, fields) => {
		return (
			<div
				key={name}
				className="text-field-array-item"
			>
				<Field
					name={name}
					key={name}
					component={ReduxControls.Input}
					placeholder={placeholder}
					onBlur={onBlur}
				/>
				{ canRemoveInput && (
					<Icon
						name="removeCircle"
						className="remove-item"
						//We use onMouseDown because it fires before the blur event on the input field
						onMouseDown={() => removeInput(name, index)}
					/>
				)}
			</div>
		);
	});

	return (
		<div className="text-field-array">
			{$inputs}
			{ canAddInput && (
				<button
					className="add-item"
					onMouseDown={addInput}
				>{addRowLabel}</button>
			)}
		</div>
	);
}

TextFieldArray.displayName = "TextFieldArray";
